export default "__VITE_ASSET__BwL0VySW__"